import { Injectable } from '@angular/core';

import { CommonRequestService, PagingParam } from './common-request.service';
import { Gfo } from './gfo.service';
import { UserService } from './user.service';
import { AppSettings } from '../app.settings';

export interface Transaction {
	type: string; // eg.'DATA LOAD'
	startTime: Date;
	endTime: Date;
	details: {
		fileName: string;
		layers: {
			name: string;
			state: string;
		}[];
	}[];
	userName: string;
	sessionId: string;
	logs?: TransactionLog[];
}
export interface TransactionInfo {
	transactions: Transaction[];
	total?: number;
}
export interface TransactionLog {
	type: 'string' | 'json';
	timestamp: string;
	message: TransactionLogMessage;
}
export type TransactionLogMessage = string | {
	type?: 'err';
	time: string;
	msg: string;
}[];

@Injectable()
export class TransactionsService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }


	getTransactions(gfo?: Gfo, paging?: PagingParam): Promise<TransactionInfo> {
		return new Promise<TransactionInfo>((resolve, reject) => {
			resolve({
				transactions: [],
				total: 0
			});
			// const url = AppSettings.serviceRootUrl + 'azgiv/transactions';
			// const params: any = {
			// 	customerId: this.userService.getUserInfo().customerId.toString()
			// };
			// if (paging) {
			// 	this.requestService.setParamsPaging(params, paging);
			// }
			// if (gfo) {
			// 	params.gfo = JSON.stringify(gfo);
			// }
			// this.requestService.requestGet(url, {
			// 	params: params
			// }, (rsp) => {
			// 	const transactions = this.handleGetTransactions(rsp.data);
			// 	resolve({
			// 		transactions: transactions,
			// 		total: rsp.totalCount
			// 	});
			// }, (err) => {
			// 	reject(err);
			// });
		});
	}
	getTransactionLog(sessionIds: string[]) {
		return new Promise<TransactionLog[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/transactionLog';
			this.requestService.requestGet(url, {
				params: {
					sessionIds: JSON.stringify(sessionIds)
				}
			}, rsp => {
				let logs: TransactionLog[] = [];
				if (rsp.data) {
					const detail = rsp.data[0].txs_detail;
					if (detail && detail.logs) {
						logs = (<any[]>detail.logs).map(l => {
							let msg: TransactionLogMessage;
							switch (l.type) {
								case 'string': msg = l.message; break;
								case 'json': msg = (<any[]>l.message).map(i => {
									let txt = Object.keys(i).find(prop => {
										if (prop !== 'typ' && prop !== 'time') {
											return true;
										}
									});
									if (i[txt] || i[txt] === 0) {
										txt = txt + ': ' + i[txt];
									}
									return {
										type: i.typ,
										time: i.time,
										msg: txt
									}
								});
							}
							const log: TransactionLog = {
								type: l.type,
								timestamp: l.timestamp,
								message: msg
							}
							return log;
						});
					}
				}
				resolve(logs);
			}, err => reject(err));
		});
	}

	// getTransactions(gfo?: Gfo, paging?: PagingParam, successCallback?: (d: TransactionInfo) => any, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'azgiv/transactions';
	// 	const params = new URLSearchParams();
	// 	params.set('customerId', this.userService.getUserInfo().customerId.toString());
	// 	if (paging) {
	// 		this.requestService.setParamsPaging(params, paging);
	// 	}
	// 	if (gfo) {
	// 		params.set('gfo', JSON.stringify(gfo));
	// 	}
	// 	const options = new RequestOptions({
	// 		params: params
	// 	});
	// 	this.requestService.requestGet(url, options, (rsp) => {
	// 		if (successCallback) {
	// 			const transactions = this.handleGetTransactions(rsp.data);
	// 			successCallback({
	// 				transactions: transactions,
	// 				total: rsp.totalCount
	// 			});
	// 		}
	// 	}, errorCallback);
	// }
	private handleGetTransactions(data): Transaction[] {
		const transcList: Transaction[] = [];
		data.forEach((d) => {
			transcList.push({
				type: d.tranx_type,
				startTime: d.txs_start,
				endTime: d.txs_end,
				details: !d.json_agg ? [] : d.json_agg.map((f) => {
					return {
						fileName: f.filename,
						layers: !f.layers ? [] : f.layers.map((l) => {
							return {
								name: l.layer_name,
								state: l.layer_state
							};
						})
					};
				}),
				userName: d.usr_name,
				sessionId: d.txs_session_id
			});
		});
		return transcList;
	}
}
